import React, { PropTypes, Component } from 'react';

import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import * as actions from './actions';

import {
  NitroLoading,
  NitroDrawer,
  NitroContentNotAvailable,
} from 'nitro-components';

import { isEmpty, cloneDeep } from 'lodash';

import ComponentFactory from '../../components/utils/ComponentFactory.js';

class InsightsSidePanel extends Component {
  componentDidMount() {
    /**if (this.props.fromNotification) {
      this.props.actions.fetchNotificationDetail(this.props.reportParam);
    }**/
  }
  componentWillReceiveProps(nextProps) {
    const { fetchSummaryDetails, fetchDataFromTable } = this.props.actions;
    const fromNotification = this.props.fromNotification;
    const { navTitle } = nextProps;

    if (nextProps.open !== this.props.open && nextProps.open) {
      const { fetchGraphDetail } = this.props.actions;

      let companyCode = this.props.companyCode;
      let id = this.props.id;
      let countryCode = this.props.country;
      const restrictions = this.props.restrictions;

      //fire if table data is not null
      if (nextProps.tableData !== this.props.tableData) {
        console.log(nextProps.tableData);
        return this.renderTableData(nextProps.tableData);
      }

      // Why are we using this.props.selectedFilters; and not nextProps.selectedFilters; -- SRIRAM Question -- TODO --changed to pick from next props, if not present from props
      //let selectedFilters = this.props.selectedFilters;
      let selectedFilters = nextProps.selectedFilters
        ? nextProps.selectedFilters
        : this.props.selectedFilters;
      if (!isEmpty(id && companyCode) && !fromNotification) {
        fetchGraphDetail(
          id,
          companyCode.value,
          countryCode.value,
          selectedFilters,
          restrictions
        );
      }
    }

    if (nextProps.tableData !== this.props.tableData) {
      console.log('tableDataUpdate', nextProps.tableData);
      return this.renderTableData(nextProps.tableData);
    }

    // fetch notiifcation details if report parameter exist
    /** if (this.props.reportParam !== nextProps.reportParam) {
        this.props.actions.fetchNotificationDetail(nextProps.reportParam);
    }**/
    // already navigated, no need for api call
    // To be checked and removed if required - Mythreyi

    // if (!fromNotification && nextProps.navTitle === this.props.navTitle) return;
    nextProps.graphDetails &&
      nextProps.graphDetails.forEach(componenetDetail => {
        const { FetchParams } = componenetDetail;
        const DisplayType = componenetDetail['@DisplayType'];

        if (DisplayType === 'remote')
          fetchSummaryDetails({ FetchParams, navTitle });
      });
  }

  renderTableData = tableData => {
    const { fetchDataFromTable } = this.props.actions;
    return fetchDataFromTable({ data: [...tableData] });
  };

  close = () => {
    this.setState({ showTable: 'allCategoriesTable' });
    this.props.close();
  };

  //TODO to clean this call to action  -//call to actions start -- TODO revisit this and reafactor and integrate with notification side panel - Sri
  arrayContains = (value, array) => {
    let found;
    for (let i = 0; i < array.length && !found; i++) {
      if (array[i] === value) {
        found = true;
        break;
      }
    }
    return found;
  };

  gerenateActionButtons = details => {
    if (!details) return null;
    let obj = null;
    const isMobile = false;

    const componenentDetails = cloneDeep(details);

    let callToAction = componenentDetails.Component;
    if (callToAction && callToAction.length > 0) {
      obj = { left: [], right: [] };
      let doubleDashboards = false;
      const componentTypes = callToAction.map((item, index) => {
        return item.componentType;
      });

      if (
        this.arrayContains('driverProfile', componentTypes) &&
        this.arrayContains('vehicleProfile', componentTypes)
      ) {
        doubleDashboards = true;
      }
      callToAction.forEach(item => {
        item.action = () => this.callToAction(item);
        switch (item.componentType) {
          case 'mobile':
            item.label = isMobile ? `Call` : `Call ${item.detail}`;

            obj.left.push(item);
            break;
          case 'email':
            item.label = `Email`;
            obj.left.push(item);
            break;
          case 'driverProfile':
            item.label =
              isMobile && !doubleDashboards ? `Profile ` : 'Driver Profile';
            item.variant = doubleDashboards ? '' : 'secondary';
            doubleDashboards ? obj.left.push(item) : obj.right.push(item);
            break;
          case 'vehicleProfile':
            item.label =
              isMobile && !doubleDashboards ? `Profile` : 'Vehicle Profile';
            item.variant = 'secondary';
            obj.right.push(item);
            break;
          default:
            return null;
        }
      });
    }

    return obj;
  };

  callToAction = item => {
    switch (item.componentType) {
      case 'mobile':
        window.location = `tel:${item.detail.replace(/\s/g, '')}`;
        break;
      case 'email':
        window.location = `mailto:${item.detail}`;
        break;
      case 'driverProfile':
        //window.open(`${item.detail}`, "_blank");
        this.context.router.push({
          pathname: '/v1' + item.detail.route,
          state: { id: item.detail.driverId, dashboardType: 'driver' },
        });
        break;
      case 'vehicleProfile':
        //window.open(`${item.detail}`, "_blank");
        this.context.router.push({
          pathname: '/v1' + item.detail.route,
          state: { id: item.detail.leaseId, dashboardType: 'vehicle' },
        });
        break;
      default:
    }
  };

  //call to actions END - Sri

  render() {
    const { drillDown, drillUp, fetchSummaryDetails } = this.props.actions;

    if (!this.props.graphDetails) return <div />;

    // inject side panel hader with default graph title if server doesn't
    // provide navigation header
    const graphDetailsWithHeader =
      this.props.graphDetails.filter(
        d => d['@DisplayType'] === 'navigation-header'
      ).length === 1
        ? this.props.graphDetails
        : [
            { '@DisplayType': 'navigation-header', Title: this.props.title },
            ...this.props.graphDetails,
          ];

    const SidePanContents =
      this.props.graphDetails &&
      this.props.graphDetails.length > 0 &&
      graphDetailsWithHeader.map((graphDetailsObj, idx) => {
        const {
          Columns,
          Rows,
          Header,
          Title,
          Footers,
          Data,
          FetchParams,
          HeaderPostFix,
          IndicatorHeader,
          ...component
        } = graphDetailsObj;
        const Variant = graphDetailsObj['@variant'];
        return (
          <ComponentFactory
            key={idx}
            {...{
              Columns,
              Rows,
              Header,
              Title,
              Footers,
              Data,
              drillDown,
              drillUp,
              fetchSummaryDetails,
              title: this.props.title,
              navTitle: this.props.navTitle,
              FetchParams,
              HeaderPostFix,
              IndicatorHeader,
              Variant,
              ...component,
            }}
          />
        );
      });

    //call to actions start -- TODO revisit this and reafactor and integrate with notification side panel - Sri

    let actionItems = [];

    const actioncalls = this.props.graphDetails.filter(function(graph) {
      return graph['@DisplayType'] === 'callToAction';
    });

    const action = actioncalls[0];
    const actionObjs = this.gerenateActionButtons(action);

    //Generate the action buttons in the side panel

    //call to actions end -- TODO revisit this and reafactor and integrate with notification side panel - Sri

    return (
      <NitroDrawer
        isOpen={this.props.open}
        close={this.close}
        width={500}
        padding="20px"
        actions={actionObjs}
        staticFooter={actionObjs != null}
        iconVariant="white"
        closeIconSize={14}
      >
        {SidePanContents}
        {this.props.fetchingGraphDetail && <NitroLoading />}
        {(this.props.dataError || !this.props.graphDetails.length) &&
          !this.props.fetchingGraphDetail && <NitroContentNotAvailable />}
      </NitroDrawer>
    );
  }
}

InsightsSidePanel.propTypes = {
  title: PropTypes.string.isRequired,
  navTitle: PropTypes.string.isRequired,
  fetchGraphDetail: PropTypes.func,
  fetchSummaryDetails: PropTypes.func,
  actions: PropTypes.object,
  companyCode: PropTypes.object.isRequired,
  country: PropTypes.object.isRequired,
  restrictions: PropTypes.array,
  id: PropTypes.string.isRequired,
  selectedFilters: PropTypes.object.isRequired,
  close: PropTypes.func.isRequired,
  open: PropTypes.bool.isRequired,
  graphDetails: PropTypes.array.isRequired,
  reportParam: PropTypes.object,
  fromNotification: PropTypes.bool,
  location: PropTypes.object,
  dataError: PropTypes.bool,
  fetchingGraphDetail: PropTypes.bool,
};

InsightsSidePanel.contextTypes = {
  router: PropTypes.object,
  location: PropTypes.object,
};
const mapStateToProps = state => {
  return {
    graphDetails: state.insights.GraphDetail,
    Description: state.insights.Description,
    title: state.insights.title || '',
    navTitle: state.insights.navTitle,
    totalTillDate: state.insights.totalTillDate,
    fetchingGraphDetail: state.insights.fetchingGraphDetail,
  };
};

const mapDispatchToProps = dispatch => ({
  actions: bindActionCreators(actions, dispatch),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(InsightsSidePanel);



// WEBPACK FOOTER //
// ./src/features/insights/InsightsSidePanel.js